import React from 'react';
import { BookOpenIcon, CalendarCheckIcon, CircleCheckBigIcon } from 'lucide-react';
import { Reveal } from '../../ui/Reveal';
import { valueStack } from '../../../data/offer';
const icons = {
  book: BookOpenIcon,
  calendar: CalendarCheckIcon,
  check: CircleCheckBigIcon
};
export function ValueStack() {
  return <div data-id="element-203" data-mp="3bqk1h9csix2w">
      <Reveal data-id="element-204" data-mp="3bqad1q7e8xzb">
        <p className="text-xs font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-205" data-mp="3bqttf2hebeb8">La oferta</p>
        <h2 id="oferta-titulo" className="mt-4 max-w-3xl text-[1.75rem] font-extrabold leading-[1.15] tracking-tight text-forest sm:text-4xl" data-id="element-206" data-mp="2e5e7y3xi5r89">
          No es solo un libro, es tu nuevo sistema operativo metabólico
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-relaxed text-body sm:text-lg" data-id="element-207" data-mp="2o06azn9ut6af">
          Al unirte hoy al Método Glucosa Estable, desbloqueas la hoja de ruta exacta que ha
          transformado la energía de miles de mujeres.
        </p>
      </Reveal>

      <ul className="mt-9 grid gap-5 md:grid-cols-3" data-id="element-208" data-mp="20avfak7d2235">
        {valueStack.map((card, index) => {
        const Icon = icons[card.icon];
        return <Reveal as="li" key={card.title} delay={index * 0.06} className="list-none" data-id="element-209" data-mp="1d7ic2eg3ct15" data-mpi={index}>
              <article className="flex h-full flex-col rounded-2xl border border-gold/50 bg-white p-7 shadow-card transition-[transform,box-shadow] duration-200 ease-smooth hover:-translate-y-0.5 hover:shadow-lift" data-id="element-210" data-mp="1d9uusttob7f9">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-cream" data-id="element-211" data-mp="zfu3um8yqopg">
                  <Icon className="h-6 w-6 text-gold" aria-hidden="true" data-id="element-212" data-mp="uhad88jfcoqr" />
                </span>
                <h3 className="mt-5 text-lg font-bold leading-snug text-forest" data-id="element-213" data-mp="pho0s1bf7cj0">{card.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-214" data-mp="kj3060s9aqu1">{card.description}</p>
              </article>
            </Reveal>;
      })}
      </ul>
    </div>;
}